import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { buildWorkOrderCreatePayload } from '#/api/momMgmt/workOrder/serializeWorkOrderWrite';

export async function createWorkOrder(values) {
  const { data: raw } = await request.post(
    '/mom/work-order',
    keysToSnake(buildWorkOrderCreatePayload(values)),
  );
  return parseVer4DetailResponse(raw);
}
